module.exports = __webpack_public_path__ + "static/media/weak_persistent_layer.9134480f.svg";